// Substring-based mapping from raw backend errors to short, user-facing
// localized messages. The raw text stays in the JobRow tooltip so support /
// debugging is not lost. Order matters: first match wins.
import i18n from "../lib/i18n";

// Ensure the management namespace (where job_errors.* live) is loaded.
void i18n.loadNamespaces("management");

type Matcher = { test: (s: string) => boolean; key: string };

const MATCHERS: Matcher[] = [
    { test: (s) => /timeout|etimedout|deadline.exceeded/i.test(s), key: "timeout" },
    { test: (s) => /rate.?limit|429|too.many.requests/i.test(s), key: "rate_limit" },
    { test: (s) => /worker.resource.limit|memory|out.of.memory|546/i.test(s), key: "resource_limit" },
    { test: (s) => /\brib\b|iban|account.?number/i.test(s), key: "invalid_account" },
    { test: (s) => /upload.failed|storage|object.not.found/i.test(s), key: "upload_failed" },
    { test: (s) => /unknown.job.type|wrong.worker/i.test(s), key: "unknown_job" },
    { test: (s) => /unauthorized|forbidden|401|403/i.test(s), key: "access_denied" },
    { test: (s) => /not.found|404/i.test(s), key: "not_found" },
    { test: (s) => /fetch.failed|network|enotfound|econnrefused|econnreset|getaddrinfo/i.test(s), key: "network" },
    { test: (s) => /jwt|invalid.token|expired.token/i.test(s), key: "session_expired" },
];

const MAX_RAW_LENGTH = 160;

export function humanizeJobError(error?: string | null): string | null {
    if (!error) return null;
    const raw = error.trim();
    if (!raw) return null;
    for (const m of MATCHERS) {
        if (m.test(raw)) return i18n.t(`management:job_errors.${m.key}`);
    }
    return raw.length > MAX_RAW_LENGTH ? `${raw.slice(0, MAX_RAW_LENGTH)}…` : raw;
}
